"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const DynamicListURLService_1 = require("./DynamicListURLService");
const DynamicListDataLoader_1 = require("./DynamicListDataLoader");
const useDynamicListDataLoader = () => {
    const [data, setData] = React.useState();
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        if (DynamicListURLService_1.dynamicListURLService.areUrlParamsSetAndValid()) {
            getData();
        }
        else {
            DynamicListURLService_1.dynamicListURLService.addDefaultParamsToUrl();
            fetchData();
        }
        const getParamsFromUrlAndLoadData = () => getData();
        globalThis.addEventListener('popstate', getParamsFromUrlAndLoadData);
        return () => {
            globalThis.removeEventListener('popstate', getParamsFromUrlAndLoadData);
        };
    }, []);
    const fetchData = (newParams) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const response = yield DynamicListDataLoader_1.dynamicListDataLoader.loadData(newParams);
        const currentPage = newParams === null || newParams === void 0 ? void 0 : newParams.page;
        const isValidUrlPageNumber = DynamicListURLService_1.dynamicListURLService.isValidUrlPageNumber(currentPage, response.pageCount);
        if (currentPage && !isValidUrlPageNumber) {
            DynamicListURLService_1.dynamicListURLService.addParamsToUrl({ page: response.pageCount });
        }
        setData(response);
        setLoading(false);
    });
    const getData = (newParams) => {
        const urlParams = DynamicListURLService_1.dynamicListURLService.getParamsFromUrl();
        DynamicListURLService_1.dynamicListURLService.addParamsToUrl(Object.assign(Object.assign({}, urlParams), newParams));
        if (!(newParams === null || newParams === void 0 ? void 0 : newParams.pageSize)) {
            fetchData(Object.assign(Object.assign({}, urlParams), newParams));
        }
    };
    return { data, loading, getData };
};
exports.default = useDynamicListDataLoader;
